var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnknownLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#6C757D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4688 20C36.4062 20 40.6719 23.1406 40.6719 27.2188C40.6719 32.6562 34.8125 32.75 34.8125 34.7656V35C34.8125 35.6562 34.2969 36.125 33.6875 36.125H30.2656C29.6562 36.125 29.1406 35.6562 29.1406 35V34.5781C29.1406 31.6719 31.3438 30.5 33.0312 29.5625C34.4375 28.7656 35.3281 28.25 35.3281 27.1719C35.3281 25.7656 33.5469 24.875 32.0938 24.875C30.2656 24.875 29.375 25.7188 28.2031 27.1719C27.8281 27.6406 27.125 27.7344 26.6562 27.3594L24.6406 25.8125C24.125 25.4844 24.0312 24.7812 24.3594 24.3125C26.2812 21.5469 28.7188 20 32.4688 20ZM32 37.5312C33.7812 37.5312 35.2344 38.9844 35.2344 40.7656C35.2344 42.5469 33.7812 44 32 44C30.1719 44 28.7188 42.5469 28.7188 40.7656C28.7188 38.9844 30.1719 37.5312 32 37.5312Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownLogo);
export default __webpack_public_path__ + "static/media/unknown-logo.8d23664d.svg";
export { ForwardRef as ReactComponent };